export const COMPONENT_NAME = "wallet-cripto-deposit-address";
